import React, { Component } from 'react';
import { getText } from '../config';

class Menu extends Component {
    componentWillMount() {
        this.height = window.innerHeight
    }

    render() {
        let className = "floating-menu";
        if(this.props.show) className = className + " show";
        if(this.props.small) className = className + " small";
        if(this.props.isStart) className = className + " start";
        if(this.props.big) className = className + " big";
        if(this.props.datesTransition) className = className + " dates-transition";

        return (
            <div className={className} style={this.props.start ? {height: this.height} : {}}>
                <div className="close-menu" onClick={this.props.closeHandler}>X</div>
                <div className={this.props.headerClass}>{this.props.headerText}</div>
                {this.props.children}
                <div className="menu-save-button">
                    <button className={"search-button" + (this.props.hideSave ? " hide" : "")} onClick={this.props.saveHandler}>{getText('save')}</button>
                </div>
            </div>
        );
    }
}

Menu.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.js